import "./Mapa.css";
import AnimarAlScroll from "../Animaciones/AnimarAlScroll";

function Mapa() {
  return (
    <section className="mapa-seccion" id="ubicacion">
      <AnimarAlScroll>
      <div className="contenedor">
        <div className="seccion-titulo">
          <p>Donde encontrarnos</p>
          <div className="linea-decorativa"></div>
          <h2>Ubicacion</h2>
        </div>

        <div className="mapa-contenedor">
          <div className="mapa-overlay-oscuro"></div>
          <iframe
            className="mapa-iframe"
            src="https://maps.google.com/maps?q=Av+18+de+Julio+y+Beisso,+Montevideo,+Uruguay&t=&z=15&ie=UTF8&iwloc=&output=embed"
            title="Mapa Glowroom MVD"
            loading="lazy"
            allowFullScreen
          />
          <div className="mapa-circulo"></div>
          <div className="mapa-info-card">
            <div className="mapa-info-texto">
              <h3>Glowroom MVD</h3>
              <p>Av. 18 de Julio y Beisso</p>
              <p>Montevideo, Uruguay</p>
            </div>
          </div>
        </div>
      </div>
      </AnimarAlScroll>
    </section>
  );
}

export default Mapa;